module.exports = __webpack_public_path__ + "img/Wp_2055.1f94ed41.png";